// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const RecurringInvoicesPage = lazy(() => import('./pages/RecurringInvoicesPage'));
const UsageBillingPage = lazy(() => import('./pages/UsageBillingPage'));
const ProrationPage = lazy(() => import('./pages/ProrationPage'));
const DunningPage = lazy(() => import('./pages/DunningPage'));
const PaymentReconciliationPage = lazy(() => import('./pages/PaymentReconciliationPage'));
const MultiCurrencyInvoicingPage = lazy(() => import('./pages/MultiCurrencyInvoicingPage'));
const SubscriptionAnalyticsPage = lazy(() => import('./pages/SubscriptionAnalyticsPage'));

export const BillingRoutes: RouteObject = {
  path: 'billing',
  element: <ModuleGuard moduleId="finance.billing" />,
  children: [
    { path: 'recurring-invoices', element: <RecurringInvoicesPage />, handle: { crumb: 'Recurring Invoices' } },
    { path: 'usage-billing', element: <UsageBillingPage />, handle: { crumb: 'Usage Billing' } },
    { path: 'proration', element: <ProrationPage />, handle: { crumb: 'Proration' } },
    { path: 'dunning', element: <DunningPage />, handle: { crumb: 'Dunning' } },
    { path: 'payment-reconciliation', element: <PaymentReconciliationPage />, handle: { crumb: 'Payment Reconciliation' } },
    { path: 'multi-currency-invoicing', element: <MultiCurrencyInvoicingPage />, handle: { crumb: 'Multi Currency Invoicing' } },
    { path: 'subscription-analytics', element: <SubscriptionAnalyticsPage />, handle: { crumb: 'Subscription Analytics' } },
  ],
};
